import React from 'react'
import T from 'prop-types'
import cx from 'classnames'


export default class OnOffSwitch extends React.PureComponent {
  static propTypes = {
    className: T.string,
    readOnly: T.bool,
    value: T.bool,
    onChange: T.func.isRequired,
    onLabel: T.string,
    offLabel: T.string
  }

  static defaultProps = {
    onLabel: 'On',
    offLabel: 'Off'
  }

  _onClick = () => {
    this.props.onChange(!this.props.value)
  }

  render() {
    const {
      readOnly,
      className,
      value,
      onLabel,
      offLabel
    } = this.props
    const isOn = !!value

    return <div
      className={cx('on_off_switch', isOn && 'on', readOnly && 'read_only', className)}
      onClick={!readOnly && this._onClick}
      role="switch"
      aria-checked={isOn}
    >
      <span className={cx(!isOn && 'active')}>{offLabel}</span>
      <div className={cx('switch', isOn ? 'on' : 'off')} />
      <span className={cx(isOn && 'active')}>{onLabel}</span>
    </div>
  }
}
